import { render, staticRenderFns } from "./animation-spine-winterbonusjagd-kingspass.vue?vue&type=template&id=48057914"
import script from "./animation-spine-winterbonusjagd-kingspass.vue?vue&type=script&lang=js"
export * from "./animation-spine-winterbonusjagd-kingspass.vue?vue&type=script&lang=js"
import style0 from "./animation-spine-winterbonusjagd-kingspass.vue?vue&type=style&index=0&id=48057914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports